import React, { useState } from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const DatePicker = (props) => {
	const { value, onChange, ...rest } = props;

	const [open, setOpen] = useState(false);

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<MuiDatePicker
				open={open}
				onOpen={() => setOpen(true)}
				onClose={() => setOpen(false)}
				renderInput={(params) => (
					<TextField
						{...params}
						fullWidth
						onClick={() => setOpen(true)}
						{...rest}
					/>
				)}
				format="YYYY-MM-DD"
				value={value || null}
				onChange={onChange}
				{...rest}
			/>
		</LocalizationProvider>
	);
};

DatePicker.propTypes = {
	value: PropTypes.any.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default DatePicker;
